import { SkipLinks } from "../skip-links/skip-links";
/**
 * Class for global accessibility logic
 * @abstract
 * @class
 */
export class AccessibilityGlobals {
    static init() {
        SkipLinks.generate();
        AccessibilityGlobals.resolveFocusHighlight();
    }
    /**
     * Adds listeners for resolving if focus highlight class should be applied to body
     * @private
     * @static
     * @class
     */
    static resolveFocusHighlight() {
        // disabling focus highlight on mousemove
        document.addEventListener('mousemove', () => {
            document.body.classList.add(AccessibilityGlobals.DISABLE_FOCUS_HIGHLIGHT_CLASS);
        });
        // enabling focus highlight on mousemove
        document.addEventListener('keydown', () => {
            document.body.classList.remove(AccessibilityGlobals.DISABLE_FOCUS_HIGHLIGHT_CLASS);
        });
    }
}
AccessibilityGlobals.DISABLE_FOCUS_HIGHLIGHT_CLASS = 'disable-focus-highlight';
